import { render, staticRenderFns } from "./ErrorPayment.vue?vue&type=template&id=6e33d164&scoped=true&"
import script from "./ErrorPayment.vue?vue&type=script&lang=js&"
export * from "./ErrorPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e33d164",
  null
  
)

export default component.exports